export default "__VITE_ASSET__BVL4BHO3__"